import React, { Component } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { FormattedMessage, injectIntl } from "react-intl";
import NoAuthorization from "../../../helpers/noAuthorization";
import NoSuccess from "../../../helpers/notSuccess";
import { CircularProgress, withStyles } from "@material-ui/core";

const styles = (theme) => ({
	dialogText: {
		margin: "25px",
		textAlign: "center",
	},
});

export class cdDelete extends Component {
	render() {
		const {
			classes,
			status,
			activeDelete,
			showDelete,
			deleteCustomDashboard,
		} = this.props;

		let comp = <div></div>;
		if (status === "loading") {
			comp = <CircularProgress></CircularProgress>;
		} else {
			comp = (
				<DialogActionsBar>
					<button className='k-button' onClick={showDelete}>
						<FormattedMessage id='no' defaultMessage='No'></FormattedMessage>
					</button>
					<button
						className='k-button'
						style={{ color: "blue" }}
						onClick={deleteCustomDashboard}
					>
						<FormattedMessage id='yes' defaultMessage='Yes'></FormattedMessage>
					</button>
				</DialogActionsBar>
			);
		}

		return (
			<React.Fragment>
				{activeDelete && (
					<Dialog
						title={this.props.intl.formatMessage({
							id: "deleteConfirm",
							defaultMessage: "Please confirm",
						})}
						onClose={showDelete}
					>
						{this.props.deniedDelete && <NoAuthorization />}
						{this.props.requestError && <NoSuccess />}

						<p className={classes.dialogText}>
							<FormattedMessage
								id='messageDelete'
								defaultMessage='Are you sure delete this record?'
							></FormattedMessage>
						</p>
						{comp}
					</Dialog>
				)}
			</React.Fragment>
		);
	}
}

export default withStyles(styles)(injectIntl(cdDelete));
